import { render, staticRenderFns } from "./lookDetail.vue?vue&type=template&id=90f3bf14&scoped=true&"
import script from "./lookDetail.vue?vue&type=script&lang=js&"
export * from "./lookDetail.vue?vue&type=script&lang=js&"
import style0 from "./lookDetail.vue?vue&type=style&index=0&id=90f3bf14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f3bf14",
  null
  
)

export default component.exports